import React from "react";
import { Col, Form } from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import { useFormContext } from "react-hook-form";
import { FormData } from "./stolarz_form_types";

export function StolarzFormUserDataInput() {
    const { formState: { errors }, register } = useFormContext<FormData>();

    return <>
        <Form.Group as={Row} className="mb-1" controlId="name">
            <Form.Label column sm="2">Imię i nazwisko/firma</Form.Label>
            <Col>
                <Form.Control type="text" placeholder="Marek Kowalski" {...register("name")} />
                {errors.name &&
                    <Form.Text className="text-danger">
                        {errors.name.message?.toString()}
                    </Form.Text>}
            </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-1" controlId="nip">
            <Form.Label column sm="2">Nip (jeśli faktura)</Form.Label>
            <Col>
                <Form.Control type="text" placeholder="" {...register("nip")} />
                {errors.nip &&
                    <Form.Text className="text-danger">
                        {errors.nip.message?.toString()}
                    </Form.Text>}
            </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-1" controlId="formBasicEmail">
            <Form.Label column sm="2">Email address</Form.Label>
            <Col>
                <Form.Control type="email" placeholder="kowalski@example.com" {...register("email")} />
                {errors.email &&
                    <Form.Text className="text-danger">
                        {errors.email.message?.toString()}
                    </Form.Text>}
            </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-1" controlId="">
            <Form.Label column sm="2">Adress</Form.Label>
            <Col>
                <Form.Control type="text" placeholder="" {...register("address")} />
                {errors.address &&
                    <Form.Text className="text-danger">
                        {errors.address.message?.toString()}
                    </Form.Text>}
            </Col>
        </Form.Group>
        <Row>
            <Col>
                <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="4">Kod pocztowy</Form.Label>
                    <Col>
                        <Form.Control type="text" {...register("postalCode")} />
                        {errors.postalCode &&
                            <Form.Text className="text-danger">
                                {errors.postalCode.message?.toString()}
                            </Form.Text>}
                    </Col>
                </Form.Group>
            </Col>
            <Col>
                <Form.Group as={Row} className="mb-1" controlId="">
                    <Form.Label column sm="3">Miasto</Form.Label>
                    <Col>
                        <Form.Control type="text" {...register("city")} />
                        {errors.city &&
                            <Form.Text className="text-danger">
                                {errors.city.message?.toString()}
                            </Form.Text>}
                    </Col>
                </Form.Group>
            </Col>
        </Row>
        <Form.Group as={Row} className="mb-1" controlId="">
            <Form.Label column sm="2">Uwagi do zamówienia</Form.Label>
            <Col>
                <Form.Control as="textarea" rows={1} {...register("summary")}></Form.Control>
                {errors.summary &&
                    <Form.Text className="text-danger">
                        {errors.summary.message?.toString()}
                    </Form.Text>}
            </Col>
        </Form.Group>
    </>
}